import type { ChatScope } from '../src/types/agent';

export type ChatFocusPayload = { clientId?: string; coachId?: string; threadId?: string; scope?: ChatScope };

const KEY = 'coachd:navigate:chat';

export function navToChat(payload: ChatFocusPayload) {
  try {
    sessionStorage.setItem(KEY, JSON.stringify(payload));
  } catch {
    /* ignored */
  }
  try {
    window.dispatchEvent(new CustomEvent('coachd:navigate:chat'));
  } catch {
    /* ignored */
  }
}

export function readAndClearChatNav(): ChatFocusPayload | null {
  try {
    const raw = sessionStorage.getItem(KEY);
    if (!raw) return null;
    sessionStorage.removeItem(KEY);
    return JSON.parse(raw);
  } catch {
    return null;
  }
}
